module.exports = __webpack_public_path__ + "img/SRB.c35422f3.png";